<h2 mat-dialog-title>Carga de Evidencia</h2>
<mat-dialog-content>
  <p>Selecciona la opción con la cual deseas cargar tu evidencia</p>
  <!-- <p>Perderas el progreso que llevas.</p> -->
</mat-dialog-content>
<mat-dialog-actions class="w-100 d-flex justify-content-around">
  <button class="btn btn-primary" (click)="confirmarSalida(1)">Tomar Captura</button>
  <button class="btn btn-primary"  (click)="confirmarSalida(2)">Cargar Archivo</button>
</mat-dialog-actions>